import { Controller } from '@hotwired/stimulus';
import { FetchRequest } from '@rails/request.js';
import Sortable from 'sortablejs';

export class SortableController extends Controller {
  static targets = ['item'];
  static values = {
    additionalParams: {
      type: Object,
      default: {},
    },
    format: {
      type: String,
      default: 'html',
    },
    handle: String,
    method: {
      type: String,
      default: 'patch',
    },
    model: String,
    param: {
      type: String,
      default: 'position',
    },
    url: String,
  };

  connect() {
    if (Sortable.active) {
      this.sortable = Sortable.get(this.element);
    } else {
      this.sortable = new Sortable(this.element, {
        handle: this.handleValue || undefined,
        onUpdate: event => this.update(event),
      });
    }
  }

  disconnect() {
    if (!Sortable.active) {
      this.sortable.destroy();
      this.sortable = undefined;
    }
  }

  async update({ item, newIndex }) {
    if (this.urlValue && this.itemTargets.length > 0) {
      const request = new FetchRequest(this.methodValue, this.urlValue, {
        body: {
          ...this.additionalParamsValue,
          items: this.itemTargets.map(item => item.dataset.sortableId),
        },
        responseKind: this.formatValue,
      });
      return await request.perform();
    }

    if (item.dataset.sortableUrl) {
      const param = this.modelValue ? `${this.modelValue}[${this.paramValue}]` : this.paramValue;
      const data = new FormData();

      data.append(param, newIndex + 1);

      const request = new FetchRequest(this.methodValue, item.dataset.sortableUrl, {
        body: data,
        responseKind: this.formatValue,
      });
      return await request.perform();
    }

    [...this.element.children].forEach((child, childIndex) => {
      const position = child.querySelector(`[name*="${this.paramValue}"]`);

      if (!position) return;

      position.value = childIndex + 1;
    });
  }
}
